<div [ngClass]="[data.type, 'd-flex', 'align-items-center', 'notif-container']">
  <fa-icon class="notif-icon" [icon]="['fas', icon]"></fa-icon>
  <div class="notif-content d-flex flex-column">
    @if (title) {
      <div class="notif-title">
        {{ title }}
      </div>
    }
    @if (safeStr !== undefined) {
      <div
        class="notif-message"
        [innerHTML]="safeStr"
      ></div>
    }
  </div>
  <div class="dissim-container" matSnackBarActions>
    <button
      mat-button
      matSnackBarAction
      (click)="snackBarRef.dismissWithAction()"
      i18n-aria-label
      aria-label="Dismiss notification"
      >
      <fa-icon [icon]="['fas', 'xmark']"></fa-icon>
    </button>
  </div>
</div>
